import { Component, HostBinding } from '@angular/core';
import {
  FieldType,
  FormlyExtension,
  FormlyFieldConfig
} from '@ngx-formly/core';
import { isValid, parseISO } from 'date-fns';
import { partnerForm } from '../../form-parts-definition';
@Component({
  selector: 'tpa-partner',
  templateUrl: './partner.component.html',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'tpa-wrapper__control' },
})
export class PartnerComponent extends FieldType implements FormlyExtension {
  defaultOptions = {
    className: 'p-col-12',
    props: {
      translate: true,
      open: true,
    },
  };

  @HostBinding('class.p-grid') someField = true;

  parseISO = parseISO;
  isValid = isValid;

  onPopulate(field: FormlyFieldConfig) {
    if (field.fieldGroup) {
      return;
    }

    // `hintKind` opts this card into the "fill from history" button; `partnerForm` places it right
    // below the `dalsiPoplatnik` yes/no, next to the taxpayer fields it fills.
    field.fieldGroup = partnerForm(false, !!field.props?.['hintKind']);
  }
}
